import topic from '../topic';
export const npsmAPI = {
  getNpsms: topic.npsmTopic + '/get_npsms',
  getNpsmById: topic.npsmTopic + '/get_npsm_by_id',
  addNpsm: topic.npsmTopic + '/add_npsm',
  editNpsm: topic.npsmTopic + '/edit_npsm',
  deleteNpsmByIds: topic.npsmTopic + '/delete_npsm_by_ids'
};
